import './bootstrap';
import 'flowbite';

// @ts-ignore
// Sera à retirer lors du passage en Laravel13 et laravel-vite-plugin v3.
// La configuration sera alors lu depuis le vite.config.js
import.meta.glob([
    '../static/images/**',
]);

import { initLocale as initCookieConsentLocale, setCurrentLocale as setCookieConsentLocale } from "@pcsoft/cookieconsent/js/lang/locales";
import { initIframeManager as initCookieConsentIframeManager } from "@pcsoft/cookieconsent/js/components/IframeManager";
import { initCookieConsent } from "@pcsoft/cookieconsent/js/components/CookieConsent";
import { initNav } from "./components/main-navigation";
import { initNavSamePageScroll } from "./components/nav-same-page-scroll";
import { initNavDropdownAutoClose } from "./components/nav-dropdown-auto-close";
import { initNavMobileAccordion } from "./components/nav-mobile-accordion";
import { initOffersUsageSwitch } from "./components/offers-usage-switch";
import { initOffersDevSupModal } from "./components/offers-dev-sup-modal";
import { initContactForm } from "./components/contact-form";
import { initYoutubePopup } from "./components/youtube-popup";
import { initNewsPagination } from "./components/news-pagination";
import { initDistributorModal } from "./components/distributor-modal";
import { initCopyCode } from "./components/copy-code";
import { initCtaFloat } from "./components/cta-float";
import { initNewCoursesPanel } from "./components/new-courses-panel";
import { initProgrammeTabs } from "./components/programme-tabs";
import { initModalAutoOpen} from "../../vendor/pcsoft/ui/resources/js/components/Modal";
import { initFollowQueryParam } from "../../vendor/pcsoft/ui/resources/js/components/FollowQueryParams";

import Events from './dom/events'

/**
 * Chargement des composants qui sont initialisé dès que le DOM est prêt (pas besoin d'attendre d'autres assets)
 * Il n'attend pas que d'autres éléments comme les images, les sous-cadres et les scripts asynchrones aient fini de charger
 * https://developer.mozilla.org/fr/docs/Web/API/Document/DOMContentLoaded_event
 */
const eventsDOMContentLoaded = new Events('DOMContentLoaded', [
    () => { initFollowQueryParam(['p']) }, // Ajouter dans le tableau les autres paramètres à faire suivre. (Ce composant doit être chargé avant toute intéraction avec des liens)
    initNav, // Dropdown dispo plus rapidement
    initNavSamePageScroll, // Scroll smooth sur clic de lien nav vers la page courante
    initProgrammeTabs, // Pages Formation : onglets sur écran large, programme des fiches et FAQ (au plus tôt, pour limiter le décalage)
])

eventsDOMContentLoaded.init()

/**
 * Chargement des composants qui ont besoin d'attendre que toutes les ressources dépendantes soit chargées
 * telles que des feuilles de style, des scripts (y compris les scripts asynchrones, différés et les modules
 * https://developer.mozilla.org/fr/docs/Web/API/Window/load_event
 */
const eventsLoad = new Events('load', [
    () => {
        const domLang = document.querySelector('html[data-lang]')?.getAttribute('data-lang');
        const lang = domLang ?? window.location.pathname.split('/')[1];
        setCookieConsentLocale(lang ?? 'fr')
        initCookieConsentLocale()
    },
    initCookieConsentIframeManager,
    initCookieConsent,
    initContactForm,
    initModalAutoOpen,
    initYoutubePopup,
    initNewsPagination,
    initDistributorModal,
    initNavDropdownAutoClose, // Fermeture auto dropdowns nav desktop : hover-out 400ms + scroll
    initNavMobileAccordion, // Menu mobile : comportement accordion à 2 niveaux (niveau 1 + niveau 2)
    initOffersUsageSwitch, // Page Offres : bascule Interne/Commercial selon l'ouverture du dropdown profils
    initOffersDevSupModal, // Page Offres : popup « Développeur supplémentaire » (clone du template par offre)
    initCopyCode, // Blocs de code : bouton de copie dans le presse-papiers
    initCtaFloat, // Bouton d'action flottant (FAB) sur les CTA marqués data-cta-float
    initNewCoursesPanel, // Pages Formation : panneau « Nouvelles formations » en bas à droite, fermable 24 h
]);

eventsLoad.init();
